import React, { useState } from "react";
import { Drawer, Button, Popover } from "antd";
import {
  LogoutOutlined,
  MenuOutlined,
  ProfileOutlined,
} from "@ant-design/icons";
import "./navbar.css";
import { Link } from "react-router-dom";
import FileList from "../content/FileList";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/user";
import ModalLogout from "../modal/ModalLogout";

const content = (
  <div className="spec-div">
    <FileList />
  </div>
);

const NavBar = () => {
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const onLogout = () => {
    try {
      dispatch(logout());
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <nav className="navbar">
      <Button
        className="menu"
        type="primary"
        icon={<MenuOutlined />}
        onClick={() => setVisible(true)}
      ></Button>
      {/* <Drawer
        title="Topics"
        placement="left"
        onClick={() => setVisible(false)}
        onClose={() => setVisible(false)}
        open={visible}
      >
        {menu}
      </Drawer> */}
      <div className="d-flex align-items-center justify-content-between">
        <Link to="/">
          <img src={"/apacanal-white.png"} className="logo" alt="logo" />
        </Link>
        {
          process.env.REACT_APP_SERVER_ENV !== "production" && (
            <span style={{
              color: "#fff",
              background: "#fa541c",
              fontWeight: "bold",
              marginLeft: "10px",
              padding: "2px 10px",
              fontSize: "14px",
              letterSpacing: "1px"
            }}>TEST</span>
          )
        }
        <div className="mx-3 text-end d-flex gap-3 justify-content-end">
          <Popover placement="bottomRight" content={content} trigger={"click"}>
            <Button type="primary" shape="circle" icon={<ProfileOutlined />} />
          </Popover>

          <Button
            type="primary"
            shape="circle"
            icon={<LogoutOutlined />}
            onClick={() => setOpen(true)}
          />
        </div>
        {/* {menu.props.topics[menu.props.selectedKey].name} */}
        <ModalLogout
          handleClose={() => setOpen(false)}
          handleOk={onLogout}
          open={open}
        />
      </div>
    </nav>
  );
};
export default NavBar;
